import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import config from '../../helpers/config'

// material ui
import Grid from '@material-ui/core/Grid';

// add custom style
import { makeStyles } from '@material-ui/core/styles';
import { Container, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    
    footerCover: {
        marginTop: 50,
        padding: 25,
        position: 'relative',
        background: 'linear-gradient(180deg, white, #eabdd7)',

        "& .bg": {
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            position: "absolute",

            [theme.breakpoints.down("sm")]: {
                display: 'none'
            },  

            "&.left": {
                left: 0,
                top: 0,
                width: "100%",
                height: "100%",
                backgroundPosition: "0% 50%",

                [theme.breakpoints.down("md")]: {
                    backgroundPosition: "-50% 50%",
                }

            },
            "&.center": {
                width: "100%",
                height: "100%",
                backgroundPosition: "50% 50%",
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
                backgroundSize: 400,

                [theme.breakpoints.down("md")]: {
                    backgroundSize: 300,
                }
            },

            "&.right": {
                right: 0,
                bottom: 0,
                width: "100%",
                height: "100%",
                backgroundPosition: "100% 50%",

                [theme.breakpoints.down("md")]: {
                    backgroundPosition: "150% 50%",
                }
            }

        }
    },

    footerContainer: {
        padding: 10,
        transform: 'translateZ(0)'
    },

    icon: {
        width: 25,
        height: 25,
        display: 'inline-block',
        verticalAlign: 'middle',
        marginRight: 10
    },

    ctxt: {
        display: 'inline-block',
        lineHeight: '25px',
        verticalAlign: 'middle'
    },

    fb_page: {
        width: 400,
        float: 'right',

        [theme.breakpoints.down("md")]: {
            width: 250,
        }, 

        [theme.breakpoints.down("sm")]: {
            paddingTop: 50,
            width: 500,
            float: 'initial',
            margin: '0 auto'
        }, 

        [theme.breakpoints.down("xs")]: {
            paddingTop: 25,
            width: 300,
        }, 
    },

    contactCol: {
        paddingTop: 50,
        [theme.breakpoints.down("sm")]: {
            paddingTop: 25,
            textAlign: 'center',
            margin: '0 auto'
        }, 
        [theme.breakpoints.down("xs")]: {
            paddingTop: 25,
            textAlign: 'center',
            margin: '0 auto'
        }, 
    },

    socialCol: {
        maxWidth: 400,
        paddingTop: 50,
        textAlign: 'center',
        
        [theme.breakpoints.down("md")]: {
            maxWidth: 250,
        },

        [theme.breakpoints.down("sm")]: {
            maxWidth: 768,
        }, 
        [theme.breakpoints.down("xs")]: {
            maxWidth: 300,
        }, 
    },

    socialIcon: {
        width: 50,
        height: 50
    },

    corpCol: {
        maxWidth: 400,
        paddingTop: 50,
        textAlign: 'center',
        
        [theme.breakpoints.down("md")]: {
            maxWidth: 250,
        },


        [theme.breakpoints.down("sm")]: {
            maxWidth: 768,
        }, 
        [theme.breakpoints.down("xs")]: {
            maxWidth: 400,
        }, 
    },

    corpIcon: {
        width: 75,
        height: 75
    }
}));

const Footer = (props) => {
    const classes = useStyles();
    const { auth } = props;
    // const authButton = auth ? 
    //     (<a href="/api/logout">Logout</a>) : 
    //     (<a href="/api/auth/google">Login</a>);
    const { footers } = auth;
    const socials = footers.social.filter((d) => !d.disabled);
    return (
        <Fragment>
            <div className={classes.footerCover}>
                <div className="bg right" style={{backgroundImage: `url(${config.S3Endpoint}${footers.bgRight})`}}></div>
                <div className="bg left" style={{backgroundImage: `url(${config.S3Endpoint}${footers.bgLeft})`}}></div>
                <div className="bg center" style={{backgroundImage: `url(${config.S3Endpoint}${footers.bgCenter})`}}></div>
                {/* <Container> */}
                    <Grid container className={classes.footerContainer}>
                        <Grid item xs={12} sm={12} md={4} lg={4} >
                            <div className={classes.contactCol}>
                                {footers.contact.map((d, i) => 
                                    <div key={i} style={{paddingBottom: 10}}>
                                        <img src={config.S3Endpoint + d.icon} className={classes.icon} />
                                        <a href={d.href} target={d.target} className={classes.ctxt}>
                                            <Typography variant="h5">{d.ctxt}</Typography>
                                        </a>
                                    </div>
                                )}
                            </div>
                            <div className={classes.socialCol}>
                                {socials.map((d, i) => {
                                    if (d.disabled) {
                                        return;
                                    }
                                    return (<div key={i} style={{width: 100 / socials.length + '%', display: 'inline-block'}}>
                                        <a href={d.ctxt}><img src={config.S3Endpoint + d.icon} className={classes.socialIcon}/></a>
                                    </div>)
                                })}
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <div className={classes.fb_page}>
                                <div className="fb-page" 
                                    data-href="https://www.facebook.com/mibaoservice/" 
                                    data-tabs="timeline" 
                                    data-width="500" 
                                    data-height="300" 
                                    data-small-header="true" 
                                    data-adapt-container-width="true"
                                    data-hide-cover="false" 
                                    data-show-facepile="true">
                                    <blockquote cite="https://www.facebook.com/mibaoservice/" className="fb-xfbml-parse-ignore">
                                        <a href="https://www.facebook.com/mibaoservice/">咪寶產後護理之家</a>
                                    </blockquote>
                                </div>
                                
                                <div className={classes.corpCol}>
                                    {footers.corp.map((d, i) => 
                                        <div key={i} style={{width: 100 / footers.corp.length + '%', display: 'inline-block'}}>
                                            <a href={d.ctxt}><img src={config.S3Endpoint + d.icon} className={classes.corpIcon}/></a>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                {/* </Container> */}
            </div>
        </Fragment>
    )
}

function mapStateToProps({ auth }) {
    return { auth };
}

export default connect(mapStateToProps)(Footer);


// WEBPACK FOOTER //
// ./src/client/components/Footer.js